import React from 'react';
import { useState } from 'react';

import t from '../Translation/Translation';
import { IonButtons, IonButton, IonContent, IonHeader, IonFooter, IonPage, IonTitle, IonToolbar, IonMenuToggle, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonIcon, IonLabel } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import Releases from '../Releases/Releases';
import Menubar from '../Dashboard/Menubar';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';

import { Avatar, Loader, CustomTable } from 'citric_components';

import { useNavigate } from 'react-router';

import CardImg from '../../images/card.png';

import conf from '../../config.json';
import { logD } from '../Util/Util';
import Header from '../Dashboard/Header';

export default function Projects(props) {
    logD("Projects", props);
    //const projects = props.projects;
    const [projects, setProjects] = useState(props.projects);

    const navigate = useNavigate();

    function back() {
        //props.setProject(null);
        props.setCustomer(null);

        setTimeout(function(){
            navigate(-1);
        }, 1);
        //navigate.go(-1);
    }

    function loadProject(item, refresh) {
        props.setProject(item);
        //props.setRefreshData(() => () => getReleases(item, true));
        if(!refresh) {
            setTimeout(function(){
                navigate("../project/"+item.idProject);
            }, 100);
        }
    }

    const columns = [
        {
            Header: t('id'),
            accessor: 'idProject',
        },
        {
            Header: t('actions'),
            id: 'actions',
            accessor: (d) => {
                return <>
                    <IonButton color="primary" onClick={(e) => {
                            e.preventDefault();
                            loadProject(d);
                        }
                    }>{t('load')}</IonButton>
                    <IonButton color="secondary" onClick={(e) => {
                            e.preventDefault();
                            /*props.setLaunch(item);
                            setTimeout(function(){
                                navigate.push('/dashboard/survey');
                            }, 1);*/
                            //openURLInNewTab(conf.BEprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.Tcontext + '?project=' + props.project.idProject + '&sv=' + item.release.idDraft + '&pl=' + item.idLaunch + '&qa=1');
                            props.setUrl(conf.BEprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.Tcontext + '?project=' + d.idProject + '&qa=1&nomb=1');
                            props.setTitle(t('tracking'));
                            props.setTypeUrl('tracking');
                            setTimeout(function(){
                                navigate('../webview/'+d.idProject);
                            }, 100);
                        }
                    }>{t('tracking')}</IonButton>
                </>
            }
        },
        {
            Header: t('code'),
            accessor: 'code',
        },
        {
            Header: t('name'),
            accessor: 'name',
        },
        {
            Header: t('desc'),
            accessor: 'desc',
        }
    ];

    var hiddenColumns = [];

    return (
        <>
            { props.token.r != 1 && <Menubar token={props.token} setToken={props.setToken} lang={props.lang} setLang={props.setLang} contentId="projects" /> } 
            <IonPage id="projects">
                <IonHeader>
                    <Header lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken}/>
                    <IonToolbar className="toolbar-azul">
                        <IonButtons slot="start">
                            { props.token.r != 1 &&
                                <IonMenuToggle className="ion-padding-start">
                                    <FontAwesomeIcon className='pointer menu_btn' icon={faBars} /><Avatar name={props.token.name.charAt(0).toUpperCase()}/>
                                </IonMenuToggle>
                            }
                            { props.token.r == 1 &&
                                <IonButton onClick={() => back()}><IonIcon icon={arrowBack}></IonIcon></IonButton>
                            }
                        </IonButtons>
                        <IonTitle>{t('projects')}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    {projects == null && <Loader />}
                    {
                        projects != null && props.token.r == 1 &&
                        <CustomTable keyField='id' desc={false} data={projects} columns={columns} isFilter={true} isPagination={true} isSelection={false} hasActions={false} hiddenColumns={hiddenColumns} isExport={true}/>
                    }
                    {
                        projects != null && props.token.r != 1 &&
                        <IonGrid>
                            <IonRow>
                            {
                                projects.map(function(item) {
                                    return <IonCol key={item.idProject} size="12" size-xl="4" size-lg="6">
                                            {/*<IonNavLink routerDirection="forward" routerLink="/releases" component={() => <Releases releases={item.draftSurveys} projects={projects} token={props.token}/>}>*/}
                                                <IonCard onClick={() => props.token.r == 4 ? loadProject(item) : ''} className="pointer">
                                                    <img src={CardImg} alt={t('bn_squared_logo')}/>
                                                    <IonCardHeader>
                                                        <IonCardTitle>{item.name}</IonCardTitle>
                                                        <IonCardSubtitle>{item.desc}</IonCardSubtitle>
                                                    </IonCardHeader>

                                                    <IonCardContent>
                                                        {props.token.r != 4 && props.token.r != 6 &&
                                                        <IonToolbar className='toolbar-buttons'>
                                                            <IonButtons slot="start">
                                                                <IonButton color="primary" onClick={(e) => {
                                                                        e.preventDefault();
                                                                        console.log(item);
                                                                        loadProject(item);
                                                                    }
                                                                }>{t('load')}</IonButton>
                                                            </IonButtons>
                                                            <IonButtons slot="end">
                                                                <IonButton color="secondary" onClick={(e) => {
                                                                        e.preventDefault();
                                                                        /*props.setLaunch(item);
                                                                        setTimeout(function(){
                                                                            navigate.push('/dashboard/survey');
                                                                        }, 1);*/
                                                                        //openURLInNewTab(conf.BEprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.Tcontext + '?project=' + props.project.idProject + '&sv=' + item.release.idDraft + '&pl=' + item.idLaunch + '&qa=1');
                                                                        props.setUrl(conf.BEprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.Tcontext + '?project=' + item.idProject + '&qa=1&nomb=1');
                                                                        props.setTitle(t('tracking'));
                                                                        props.setTypeUrl('tracking');
                                                                        setTimeout(function(){
                                                                            navigate('../webview/'+item.idProject);
                                                                        }, 100);
                                                                    }
                                                                }>{t('tracking')}</IonButton>
                                                            </IonButtons>
                                                        </IonToolbar>}
                                                    </IonCardContent>
                                                </IonCard>
                                            {/*</IonNavLink>*/}
                                        </IonCol>
                                })
                            }
                            </IonRow>
                        </IonGrid>
                    }
                    {/*<IonReactRouter>
                        <IonRouterOutlet>
                            <Route path="/releases" render={() => project != null && <Releases releases={project.draftSurveys}/> } />
                        </IonRouterOutlet>
                    </IonReactRouter>*/}
                </IonContent>
                <IonFooter>
                    <IonToolbar>
                        <IonTitle className="text-center">{t('logged_in_as')} <span className='color-orange'><b>{props.token.name}</b></span></IonTitle>
                    </IonToolbar>
                </IonFooter>
            </IonPage>
        </>
    );
}